import { Component,Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';

@Component({
  selector: 'app-view-script',
  templateUrl: './view-script.component.html',
  styleUrls: ['./view-script.component.css'],
  standalone: true,
  imports: [CommonModule, JsonPipe]
})
export class ViewScriptComponent implements OnInit {

  @Input() scriptResponse: string;
  @Output() closeModal = new EventEmitter<void>();

  onCloseModal(): void {
    this.closeModal.emit();
  }

  parseScriptResponse(scriptResponse: string): any {
    if (scriptResponse.includes('{')) {
        return JSON.parse(scriptResponse);
      } else {
        return scriptResponse;
      }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
